import React from "react";
import { useTranslation } from "react-i18next";

// Components
import Input from "../../../components/FormElements/Input";
import CheckboxList from "../../../components/FormElements/CheckboxList";
import Radio from "../../../components/FormElements/Radio";

//
import PlacerHolderImage from "../../../images/placeholder-img.png";
import iTuneCategories from "../../../data/iTuneCategories";

const GeneralInformation = ({
  isActive,
  errors,
  checkboxList,
  latestImageUrl,
  isValid,
  setValidateClicked,
  validateClicked,
}) => {
  let isValidExcludingEpisodesLength = false;
  const isValidArray = Object.keys(errors);

  if (
    (isValidArray.length === 1 &&
      isValidArray[0] === "episodes" &&
      errors["episodes"].message) ||
    isValidArray.length === 0
  ) {
    isValidExcludingEpisodesLength = true;
  }

  const { t } = useTranslation();

  return (
    <div
      className={`col-12 col-md-4 pt-4 pe-4 col-scrollable ${
        isActive ? "" : "d-none d-md-block"
      }`}
      id="sec-general"
    >
      <h2>{t("generalForm.mainTitle")}</h2>
      <Input
        label={t("generalForm.titleLabel")}
        id="title"
        name="title"
        placeholder=""
        marginBottom="sm"
        error={errors?.title?.message}
      />

      <div className="row">
        <div className="col-3">
          <img
            className="img-fluid mb-2"
            src={latestImageUrl || PlacerHolderImage}
            alt=""
          />
        </div>
        <div className="col-9 ps-0">
          <Input
            label={t("generalForm.imageUrlLabel")}
            id="image_url"
            name="image_url"
            placeholder="https://url.com/image.jpg"
            error={errors?.image_url?.message}
          />

          <p className="sub my-1">{t("generalForm.imageUrlDescription")}</p>
        </div>
      </div>

      <Input
        label={t("generalForm.subtitleLabel")}
        id="subtitle"
        name="subtitle"
        placeholder=""
        marginBottom="sm"
        error={errors?.subtitle?.message}
      />
      <Input
        label={t("generalForm.summaryLabel")}
        id="summary"
        name="summary"
        placeholder=""
        marginBottom="sm"
        text
        error={errors?.summary?.message}
      />
      <Input
        label={t("generalForm.authorLabel")}
        id="author"
        name="author"
        placeholder=""
        marginBottom="sm"
        error={errors?.author?.message}
      />
      <Input
        label={t("generalForm.ownerLabel")}
        id="owner"
        name="owner"
        placeholder=""
        marginBottom="sm"
        error={errors?.owner?.message}
        tip={t("generalForm.ownerTip")}
      />
      <Input
        label={t("generalForm.websiteUrlLabel")}
        id="url"
        name="url"
        placeholder=""
        marginBottom="sm"
        error={errors?.url?.message}
      />
      <Input
        label={t("generalForm.languageLabel")}
        id="lang"
        name="lang"
        placeholder=""
        marginBottom="sm"
        error={errors?.lang?.message}
      />
      <Input
        label={t("generalForm.copyrightLabel")}
        id="copyright"
        name="copyright"
        placeholder=""
        marginBottom="sm"
        error={errors?.copyright?.message}
      />
      <Input
        label={t("generalForm.contactEmailLabel")}
        id="cemail"
        name="cemail"
        placeholder=""
        marginBottom="sm"
        error="Invalid email address."
        error={errors?.cemail?.message}
      />
      <CheckboxList
        options={iTuneCategories}
        validateClicked={validateClicked}
        control={checkboxList}
        tip={t("generalForm.categoriesTip")}
      />
      <Input
        label={t("generalForm.keywordsLabel")}
        id="keywords"
        name="keywords"
        placeholder="news, comedy"
        marginBottom="sm"
        error={errors?.keywords?.message}
      />
      <Radio
        label={t("generalForm.ageRestrictionLabel")}
        name={`age_restriction`}
        id={`age_restriction`}
        options={[
          {
            id: `age_restriction-false`,
            value: "false",
            label: t("generalForm.ageRestrictionClean"),
            checked: false,
          },
          {
            id: `age_restriction-true`,
            value: "true",
            label: t("generalForm.ageRestrictionExplicit"),
            checked: false,
          },
        ]}
        error={errors?.age_restriction?.message}
        tip={t("generalForm.ageRestrictionTip")}
      />
    </div>
  );
};

export default GeneralInformation;
